// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const YouTube: MarkdocTagRegistration = {
  tag: 'youtube',
  component: 'YouTube',
  selfClosing: true,
  attributes: {
    src: {type: String, required: true},
    width: {type: Number},
    height: {type: Number},
    controls: {type: Boolean},
  },
};
